import React from 'react';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { SvgIcon } from '../../../Icon';
import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

const HeaderContainer = styled.div`
  display: flex;
  margin-bottom: 8px;
  justify-content: space-between;
`;

const DateDisplay = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
  > span:first-child {
    margin-right: 4px;
  }
`;

const ButtonGroupContainer = styled.div`
  display: inline-flex;
  align-items: center;
  column-gap: 8px;
`;

export default ({
  monthDate,
  decreaseMonth,
  increaseMonth,
}: ReactDatePickerCustomHeaderProps) => {
  const displayMonthName = monthDate.toLocaleString('en-US', {
    month: 'long',
  });

  return (
    <HeaderContainer>
      <DateDisplay>
        <span>{displayMonthName}</span>
        <span>{monthDate.getFullYear()}</span>
      </DateDisplay>
      <ButtonGroupContainer>
        <SvgIcon
          name="caret-left-fill"
          width={12}
          height={12}
          onClick={decreaseMonth}
          isHoverable={true}
        />
        <SvgIcon
          name="caret-right-fill"
          width={12}
          height={12}
          onClick={increaseMonth}
          isHoverable={true}
        />
      </ButtonGroupContainer>
    </HeaderContainer>
  );
};
